var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcnUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.43815 8.35449C5.43815 8.59612 5.24227 8.79199 5.00065 8.79199C4.75903 8.79199 4.56315 8.59612 4.56315 8.35449V1.81819L2.24093 4.1403C2.07158 4.30965 1.79701 4.30965 1.62766 4.1403C1.45831 3.97094 1.45831 3.69637 1.62766 3.52702L4.69402 0.460672C4.86337 0.291323 5.13794 0.291323 5.30729 0.460672L8.37364 3.52702C8.54299 3.69637 8.54299 3.97094 8.37364 4.1403C8.20429 4.30965 7.92972 4.30965 7.76037 4.1403L5.43815 1.8181V8.35449Z",
    fill: "#2D72FE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.22982 9.66699C9.47144 9.66699 9.66732 9.86287 9.66732 10.1045C9.66732 10.3461 9.47144 10.542 9.22982 10.542H0.771484C0.52986 10.542 0.333984 10.3461 0.333984 10.1045C0.333984 9.86287 0.52986 9.66699 0.771484 9.66699H9.22982Z",
    fill: "#2D72FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnUpload);
export default __webpack_public_path__ + "static/media/icn_upload.4ecbc785d25eb908613a78f7fc41dba0.svg";
export { ForwardRef as ReactComponent };